import { CategoryTemplate } from "portal/views/categoryTemplates/CategoryTemplate";
import { CategoryTemplatesList } from "portal/views/categoryTemplates/CategoryTemplatesList";
import { Slug } from "portal/utils/routing";
import { UnauthorizedPage } from "portal/components/UnauthorizedPage";
import { useRoutes } from "react-router-dom";
import { withCategoryTemplatesReadAccess } from "portal/views/categoryTemplates/permissions";
import React, { FunctionComponent } from "react";

const _CategoryTemplatesRoutes: FunctionComponent = () => {
  return useRoutes([
    { path: "/", element: <CategoryTemplatesList /> },
    {
      path: `/:id/${Slug.EDIT}?`,
      element: <CategoryTemplate />,
    },
  ]);
};

export const CategoryTemplatesRoutes = withCategoryTemplatesReadAccess(
  _CategoryTemplatesRoutes,
  <UnauthorizedPage />
);
